import SortOrder from '~/client/src/shared/enums/SortOrder'
import { compareLabelPaths } from '~/client/src/shared/utils/compareGroupsByLabel'

import { ResourceSortKey } from './types'

const compareResourceSortKeys = (
  aValue: ResourceSortKey,
  bValue: ResourceSortKey,
  order: SortOrder,
): number => {
  if (aValue == null && bValue == null) return 0
  if (aValue == null) return 1
  if (bValue == null) return -1

  if (Array.isArray(aValue) && Array.isArray(bValue)) {
    const comparison = compareLabelPaths(aValue, bValue)
    return order === SortOrder.ASC ? comparison : -comparison
  }

  const comparison =
    typeof aValue === 'number' && typeof bValue === 'number'
      ? aValue - bValue
      : String(aValue).localeCompare(String(bValue))

  return order === SortOrder.ASC ? comparison : -comparison
}

export const sortRecordsBySortKey = <T>(
  records: T[],
  getSortKey: (record: T) => ResourceSortKey,
  order: SortOrder,
): T[] =>
  records
    .map(record => ({ record, sortKey: getSortKey(record) }))
    .sort((a, b) => compareResourceSortKeys(a.sortKey, b.sortKey, order))
    .map(decorated => decorated.record)
